<template>
  <div class="w-full relative flex flex-col space-y-2.5 pt-0.5 pb-2.5 rounded">
    <div class="w-full px-2 mt-0.5 font-manrope" :class="{'mt-9':isFullscreen}">
      <input 
        v-model="searchStudents" 
        placeholder="Search..." 
        class="bg-white border border-solid border-gray-200 rounded-lg py-2 px-3 w-full focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      />
    </div>
    <div v-if="searchStudents !== ''" class="flex flex-col space-y-2 flex-grow h-full w-full">
      <ul v-if="studentsFiltered.length !== 0">
        <li v-for="(student, index) in studentsFiltered" :key="index">
          <div :class="{'opacity-50':!isStudentOnline(student.user_id)}" class="py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg px-3.5 text-gray-900 cursor-pointer">
            <div @click="openParticipantFromTapIn(student.user_id)" class="flex items-center space-x-2.5">
              <div class="relative">
                <img :src="student.user.avatar_url" class="w-6 rounded-full object-cover h-6"/>
              </div>
              <span class="text-ellipsis truncate">
                {{ student.user.name }}
              </span>
            </div>
            <div class="flex items-center space-x-2">
              <div>
                <div v-if="student.turn_count !== '0'" class="space-x-1 flex items-center">
                  <i class="fa-solid fa-bullhorn text-gray-700 text-xs"></i>
                  <span>{{ studentInCircleTurnCount(student.id) }}</span>
                  
                </div>
              </div>
              <pl-menu direction="right" :menuSize="3">
                <button slot="menu_trigger" class="rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200">
                  <i class="fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"></i>
                </button>
                <ul menu-content>
                  <Actions
                    @setAsModerator="$emit('setAsModerator', student)"
                    selectedUserType="TapIn"
                    :selectedStudent="student"
                    @handleNudge="$emit('openSendNudge', true, student)"
                  />
                </ul>
              </pl-menu>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-else class="flex flex-col space-y-2 flex-grow h-full w-full px-1">
      <div id="speaker-spot" class="w-full flex mt-0.5 flex-col space-y-2">
        <div class="flex justify-between items-center text-gray-800 font-semibold px-2">
          <h6 class="cursor-default font-manrope font-semibold">Speaker</h6>
          <button
            @click="removeSpeaker(currentSpeaker.user.id)"
            v-if="getCurrentDiscussion.currently_active"
            class="sample hover:underline text-xs subpixel-antialiased text-gray-500"
          >
            Clear
          </button>
        </div>
        <div>
          <div v-if="getCurrentDiscussion.currently_active" class="py-2.5 flex justify-between items-center rounded-lg bg-lightBlue-100 cursor-pointer px-3.5 text-gray-900">
            <div @click="handleOpenParticipantAssessment(currentSpeaker)" class="flex items-center cursor-pointer space-x-3">
              <div class="w-6 relative h-6 rounded-full ring-2 ring-lightBlue-500 ring-offset-2">
                <img class="rounded-full" :src="currentSpeaker.user.avatar_url"/>
              </div>
              <div>
                <span class="w-full text-ellipsis truncate font-manrope">
                  {{ currentSpeaker.user.name }}
                </span>
              </div>
            </div>
            <div class="flex space-x-2 items-center sample">
              <div class="flex items-center space-x-2">
                <div v-if="isUserModerator(currentSpeaker.id)" class="space-x-1 flex items-center">
                  <i class="fa-solid fa-gavel text-xs text-gray-700"></i>
                </div>
                <div v-if="currentSpeaker.turn_count !== '0'" class="space-x-1 flex items-center">
                  <i class="fa-solid fa-bullhorn text-gray-700 text-xs"></i>
                  <span>{{ currentSpeaker.turn_count }}</span>
                </div>
              </div>
              <pl-menu direction="right" :menuSize="3">
                <button slot="menu_trigger" class="rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200">
                  <i class="fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"></i>
                </button>
                <ul menu-content>
                  <Actions
                    @setAsModerator="$emit('setAsModerator', currentSpeaker)"
                    selectedUserType="Speaker"
                    :selectedStudent="currentSpeaker"
                    @handleNudge="$emit('openSendNudge', true, currentSpeaker)"
                  />
                </ul>
              </pl-menu>
            </div>
          </div>
          <div v-if="!getCurrentDiscussion.currently_active" class="py-0.5 px-3.5 cursor-default">
            <span class="text-gray-400">No Speaker</span>
          </div>
        </div>
        
      </div>
      <div id="tapped-in-spot" class="flex flex-col space-y-2 w-full">
        <div class="flex justify-between items-center text-gray-800 font-semibold px-2">
          <h6 class="cursor-default font-semibold font-manrope">
            Tapped In
            <span v-if="getCurrentDiscussion.currently_active">
              ({{ usersInCircle.length - 1 }})
            </span>
            <span v-else> ({{ usersInCircle.length }}) </span>
          </h6>
          <button
            v-if="studentsTappedIn > 0"
            @click="removeAllTapIn"
            class="sample hover:underline py-1 text-xs subpixel-antialiased text-gray-500"
          >
            Clear All
          </button>
        </div>
        <div v-if="usersInCircle.length > 0">
          <div>
            <ul v-for="(studentInCircle, index) in usersInCircle" :key="index">
              <li v-if="studentInCircle.participation.user.id !== getCurrentDiscussion.currently_active">
                <div class="py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg px-3.5 text-gray-900 cursor-pointer">
                  <div @click="openParticipantFromTapIn(studentInCircle.participation.user.id)" class="flex items-center space-x-2.5">
                    <div class="relative">
                      <img :src="studentInCircle.participation.user.avatar_url" class="w-6 rounded-full object-cover h-6"/>
                    </div>
                    <span class="text-ellipsis truncate font-manrope">
                      {{ studentInCircle.participation.user.name }}
                    </span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <div class="flex space-x-2 items-center">
                      <div v-if="isUserModerator(studentInCircle.participation_id)" class="space-x-1 flex items-center">
                        <i class="fa-solid fa-gavel text-xs text-gray-700"></i>
                      </div>
                      <div v-if="studentInCircle.turn_count !== '0'" class="space-x-1 flex items-center">
                        <i class="fa-solid fa-bullhorn text-gray-700 text-xs"></i>
                        <span>{{ studentInCircleTurnCount(studentInCircle.participation.id) }}</span>
                      </div>
                      
                    </div>
                    <pl-menu direction="right" :menuSize="3">
                      <button slot="menu_trigger" class="rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200">
                        <i class="fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"></i>
                      </button>
                      <ul menu-content>
                        <Actions
                          @setAsModerator="$emit('setAsModerator', studentInCircle.participation)"
                          selectedUserType="TapIn"
                          :selectedStudent="studentInCircle"
                          :selectedTapInUser="studentInCircle"
                          @handleNudge="$emit('openSendNudge', true, studentInCircle.participation)"
                        />
                      </ul>
                    </pl-menu>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="py-0.5 px-3.5 cursor-default">
          <span class="text-gray-400">No tapped in students</span>
        </div>
      </div>
      <div id="online-spot">
        <div class="flex justify-between items-center text-gray-800 font-semibold px-2 mb-1">
          <h6 class="cursor-default font-semibold font-manrope">Online ({{ studentsOnline }})</h6>
          <button @click="isOnlineMenuOpen = !isOnlineMenuOpen" class="p-1">
            <i :class="isOnlineMenuOpen ? 'fa-angle-down' : 'fa-angle-up'" class="fa-solid text-base text-gray-600"></i>
          </button>
        </div>
        <div v-if="studentsOnline > 0">
          <ul v-if="isOnlineMenuOpen === true">
            <li v-for="(student, index) in studentsFiltered" :key="index">
              <div
                @click="handleOpenParticipantAssessment(student)" 
                v-if=" isStudentOnline(student.user_id) && isStudentNotInCircle(student.user_id) && student.user_id !== getCurrentDiscussion.currently_active"
                class="py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg cursor-pointer px-4 text-gray-900"
              >
                <div class="flex items-center space-x-2.5 relative">
                  <div class="relative">
                    <img :src="student.user.avatar_url" class="w-6 rounded-full object-cover h-6"/>
                    <div class="absolute bottom-0 right-0 h-2 w-2 bg-green-500 rounded-full"></div>
                  </div>
                  <span class="text-ellipsis truncate">
                    {{ student.user.name }}
                  </span>
                </div>
                <div class="flex items-center space-x-2">
                  <div v-if="isUserModerator(student.id)">
                    <i class="fa-solid fa-gavel text-xs text-gray-700"></i>
                  </div>
                  <pl-menu direction="right" :menuSize="3">
                    <button slot="menu_trigger" class="rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200">
                      <i class="fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"></i>
                    </button>
                    <ul menu-content>
                      <Actions
                        @setAsModerator="$emit('setAsModerator', student)"
                        selectedUserType="Online"
                        :selectedStudent="student"
                        @handleNudge="$emit('openSendNudge', true, student)"
                      />
                    </ul>
                  </pl-menu>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-else class="py-0.5 px-3.5 cursor-default">
          <span class="text-gray-400">No students online</span>
        </div>
      </div>
      <div id="offline-spot">
        <div class="flex justify-between items-center text-gray-900 font-semibold px-2 font-manrope mb-1">
          <h6 class="font-semibold text-gray-400">
            Offline ({{ studentsOffline }})
          </h6>
          <button @click="isOfflineMenuOpen = !isOfflineMenuOpen" class="p-1">
            <i v-if="studentsOffline > 0" :class="isOfflineMenuOpen ? 'fa-angle-down' : 'fa-angle-up'" class="fa-solid text-base text-gray-700"></i>
          </button>
        </div>
        <div>
          <ul v-if="isOfflineMenuOpen === true">
            <li
              v-if="!isStudentOnline(studentParticipant.user.id) && isStudentNotInCircle(studentParticipant.user.id)"
              v-for="(studentParticipant, index) in studentsFiltered"
              @click="handleOpenParticipantAssessment(studentParticipant)"
              :key="index"
              class="py-2.5 flex justify-between items-center rounded-lg cursor-default hover:bg-gray-100 px-3.5 text-gray-400"
              v-on:mouseover="activeTapInOption = index"
              v-on:mouseout="activeTapInOption = null"
            >
              <div class="flex items-center space-x-2.5">
                <span>{{ studentParticipant.user.name }}</span>
              </div>
              <button
                v-if="discussionIsLive && !audioVideoIsActive && !isStudentInCircle.includes(studentParticipant.id)"
                v-show="activeTapInOption === index"
                @click.stop="tapInByTeacher(studentParticipant.user.id)"
                :disabled="tapin"
                class="sample hover:text-yellow-500 px-2"
              >
                <i class="fa-solid fa-arrow-up-from-bracket rotate-90"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import {
    clearAllTapIns,
    addStudentToCircle,
  } from 'services/liveDiscussion/circle/circleServices.js';
  import toggleStudentParticipationAudio from 'services/liveDiscussion/toggleStudentParticipationAudio.js';
  import toggleStudentParticipationVideo from 'services/liveDiscussion/toggleStudentParticipationVideo.js';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    components: {
      Actions: () => import('./Actions.vue'),
    },
    data() {
      return {
        searchStudents: '',
        isOfflineMenuOpen: true,
        isOnlineMenuOpen: true,
        isSearchBoxOpen: false,
        activeTapInOption: null,
        tapin: false,
        isHoveringStudent: null
      };
    },
    computed: {
      ...mapGetters([
        'getLiveDiscussionMagicLink',
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
        'getCourseLayoutFullScreenStatus',
        'getQueue',
        'getStudentsInCourse',
      ]),
      studentsFiltered: function () {
        const participations = this.getCurrentDiscussion.participations;
        if (!this.searchStudents) return participations;
        return participations.filter((p) => {
          if (p.user.name)
            return p.user.name
              .toLowerCase()
              .includes(this.searchStudents.toLowerCase());
        });
      },
      studentsOffline() {
        let offlineCount = 0;
        const participations = this.getCurrentDiscussion.participations;
        participations.forEach((p) => {
          if (
            !this.isStudentOnline(p.user.id) &&
            this.isStudentNotInCircle(p.user.id)
          )
            offlineCount += 1;
        });
        return offlineCount;
      },
      studentsOnline() {
        let onlineCount = 0;
        this.getCurrentDiscussion.participations.forEach((participation) => {
          let isInCircle = this.getCurrentDiscussion.turns_in_circle.filter(
            (t) =>
              t.participation_id === participation.id &&
              t.turn_type !== 'video_audio_on'
          );
          if (
            this.isStudentOnline(participation.user.id) &&
            participation.user.id !== this.currentSpeaker.user_id &&
            isInCircle.length === 0
          )
            onlineCount += 1;
        });
        return onlineCount;
      },
      isStudentInCircle: function () {
        return this.getCurrentDiscussion.turns_in_circle.map(
          (t) => t.participation.id && t.turn_type !== 'video_audio_on'
        );
      },
      usersInCircle: function () {
        if (this.getCurrentDiscussion.turns_in_circle.length) {
          return this.getCurrentDiscussion.turns_in_circle.filter(
            (t) => t.turn_type !== 'video_audio_on'
          );
        }
        return [];
      },
      currentSpeaker() {
        const speaker = this.getCurrentDiscussion.participations.find(
          (p) => p.user_id === this.getCurrentDiscussion.currently_active
        );
        const turn = this.getCurrentDiscussion.turns_in_circle.find(
          (t) =>
            t.participation.user.id ===
            this.getCurrentDiscussion.currently_active
        );
        if (speaker) {
          speaker.turn_type = turn ? turn.turn_type : '';
        }
        return speaker || {};
      },
      audioVideoIsActive() {
        return this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
      discussionIsLive() {
        return this.getCurrentDiscussion.is_live;
      },
      studentsTappedIn() {
        let count = this.usersInCircle.length;
        if (this.getCurrentDiscussion.currently_active) {
          count = this.usersInCircle.length - 1;
          return count;
        }
        return count;
      },
    },
    props: {
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleOpenParticipantAssessment: async function(student) {
        const participation = await this.$store.dispatch('fetchParticipationSummary', student.id);
        this.$emit('openParticipantSidebar', true, participation);
        return;
      },
      removeDuplicadosEGuardarRemovidos(array) {
        const conjunto = {};
        const arraySemDuplicados = [];
        const elementosRemovidos = [];

        array.forEach((item) => {
          if (!conjunto[item]) {
            conjunto[item] = true;
            arraySemDuplicados.push(item);
          } else {
            elementosRemovidos.push(item);
          }
        });

        return { arraySemDuplicados, elementosRemovidos };
      },
      determineTurnTypeIconHTML(type) {
        let icon = `<i class="fas `;
        let img = `<img
                  class="h-4 w-4"
                  src="/static/live_discussion/ld_question_icon.svg"
                />`;
        switch (type) {
          case 'new_idea':
            icon += 'fa-play text-primary" ';
            break;
          case 'build_on':
            icon += 'fa-square text-green-700" ';
            break;
          case 'challenge':
            icon += 'fa-circle text-pinky" ';
            break;
          case 'question':
            img;
            break;
          case 'hand_raise':
            icon += 'fa-chalkboard-user text-orange" ';
            break;
          default:
            icon = '';
        }
        if (icon && type !== 'question') {
          icon += '></i>';
          return icon;
        } else if (img && type === 'question') {
          return img;
        } else {
          return '';
        }
      },
      isUserModerator(participationID) {
        const userModerator = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (userModerator && userModerator.is_moderator) return true;
        return false;
      },
      isStudentOnline: function (studentId) {
        return this.getCurrentDiscussion.users_present.includes(studentId);
      },
      studentInCircleTurnCount(participationID) {
        const p = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (p) {
          return p.turn_count;
        }
        return 0;
      },
      studentInCircleaudioIsEnabled(participationID) {
        const p = this.getCurrentDiscussion.participations.find(
          (p) => p.id === participationID
        );
        if (p) {
          return p.audio_is_enabled;
        }
        return undefined;
      },
      isStudentNotInCircle(user_id) {
        let isInCircle = this.getCurrentDiscussion.turns_in_circle.filter(
          (t) =>
            t.participation.user.id === user_id &&
            t.turn_type !== 'video_audio_on'
        );
        if (user_id !== this.currentSpeaker.user_id && !isInCircle.length)
          return true;
        return false;
      },
      openParticipantFromTapIn: function (studentCircleId) {
        this.studentsFiltered.map((student) => {
          if (student.user.id === studentCircleId)
            this.$emit('openParticipantSidebar', true, student);
        });
      },
      autoTurnSpeaker: async function () {
        EventBus.$emit('queueLoading', true);
        await this.$store
          .dispatch('autoTurnSpeaker', {
            discussion_id: this.getCurrentDiscussion.id,
            hand_raise_type: 'hand_raise_type',
          })
          .then((res) => {
            if (res.failedReason || res.error)
              EventBus.$emit('queueLoading', false);
          })
          .catch(() => EventBus.$emit('queueLoading', false));
      },
      removeSpeaker: async function (userId) {
        if (userId === this.getCurrentDiscussion.currently_active) {
          const participation = this.getCurrentDiscussion.participations.find(
            (x) => x.user_id === userId
          );
          if (this.audioVideoIsActive) {
            if (participation.audio_is_enabled)
              await toggleStudentParticipationAudio(
                this.$route.params.liveDiscussionID,
                participation.id
              );
            if (participation.video_is_enabled)
              await toggleStudentParticipationVideo(
                this.$route.params.liveDiscussionID,
                participation.id
              );
          }
          this.$store.dispatch('tapOut', {
            discussion_id: this.getCurrentDiscussion.id,
            user_id: userId,
            participation_id: participation.id,
          });
        }
      },
      removeAllTapIn: function () {
        const payload = {
          speaker_id: this.getCurrentDiscussion.currently_active,
          participants_in_queue: this.getCurrentDiscussion.queue.map(
            (q) => q.user_id
          ),
        };
        clearAllTapIns(this.getCurrentDiscussion.id, payload);
      },
      tapInByTeacher: function (userId) {
        this.tapin = true;
        addStudentToCircle(this.getCurrentDiscussion.id, userId)
          .then(({ data }) => {
            this.tapin = false;
            if (data) {
              if (
                this.getCurrentDiscussion.auto_turn &&
                !this.getCurrentDiscussion.currently_active &&
                !this.getCurrentDiscussion.queue.length
              ) {
                this.autoTurnSpeaker();
              }
            }
          })
          .catch((error) => {
            this.tapin = false;
            console.error(error);
          })
          .finally(() => (this.tapin = false));
      },
    },
  });
</script>
<style scoped>
  .max-height-list {
    max-height: calc(100vh - 243px);
    min-height: calc(100vh - 243px);
    overflow-y: scroll;
  }
  .max-height-list-fullscreen {
    max-height: calc(100vh - 94px);
    min-height: calc(100vh - 94px);
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// ListParticipants.vue?c9a2787c